import Button from 'components/Button';
import TooltipWrapper from 'components/Tooltip';
import {FC, useState} from 'react';
import {useBackend} from 'state/backend';

import {BackendData} from '../../types';
import ApprovalFlowForm from '../ApprovalFlowForm';

const ModalFlowEdit: FC<{
    mid: string;
}> = ({mid}) => {
    const {data} = useBackend<BackendData>();
    const [open, setOpen] = useState(false);
    const flow = data.approvalFlows.find((flow) => flow.mid === mid);
    if (!flow) {
        throw new Error('Flow not found');
    }
    return (
        <>
            <TooltipWrapper
                message={data.permissions.canCreateApproval.failureReason}
            >
                <Button
                    data-testid="edit"
                    disabled={!data.permissions.canCreateApproval.allowed}
                    icon="edit"
                    kind="secondary"
                    onClick={() => setOpen(true)}
                    size="xs"
                />
            </TooltipWrapper>
            <ApprovalFlowForm
                actionType="edit"
                initialData={{
                    documentType: flow.documentType,
                    mid: flow.mid,
                    name: flow.name,
                    steps: flow.steps,
                }}
                open={open}
                setOpen={setOpen}
            />
        </>
    );
};

export default ModalFlowEdit;
